import { render, staticRenderFns } from "./SeletorPeriodo.vue?vue&type=template&id=688b82a0&scoped=true"
import script from "./SeletorPeriodo.vue?vue&type=script&lang=js"
export * from "./SeletorPeriodo.vue?vue&type=script&lang=js"
import style0 from "./SeletorPeriodo.vue?vue&type=style&index=0&id=688b82a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b82a0",
  null
  
)

export default component.exports